import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Button, ButtonGroup, CloseButton, Container, FloatingLabel, Form, Image, InputGroup, ProgressBar, Spinner, Tab, Tabs, ToggleButton } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { LoginInfo } from '../App';
import ImageFile from '../domain/ImageFile';
import * as ImageUtil from '../service/ImageUtil';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import MosaicEditPopup from './MosaicEditPopup';
import MuiButton from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import { TextField, Tooltip, useTheme } from '@mui/material';
import { Typeahead } from 'react-bootstrap-typeahead' ;
import 'react-bootstrap-typeahead/css/Typeahead.css' ;

const EditPopup = (props) => {
    async function getImageInfo(groupId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/infoLatest/"+groupId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteImage(groupId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/post/"+groupId).then((r)=>r.json().then((d)=>{
            return d
        }))
    }
    async function getPlanList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/plan/peoples/")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getLimitedDataList(groupId,index){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/limitedData/"+groupId+"/"+index).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getCharacterList(word){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/character/allowFanart",{word:word}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate();

    // 年齢制限
    const [ageLimit,setAgeLimit] = useState("")
    const [ageLimitLock,setAgeLimitLock] = useState("")
    const [sexualExpression,setSexualExpression] = useState('')

    // 画像情報
    const [imageInfo,setImageInfo] = useState({info:{id:"",title:"",description:""}});
    const [imageInfoStatus,setImageInfoStatus] = useState(false);
    const [detailId,setDetailId] = useState(0)
    const [detailNo,setDetailNo] = useState(0)
    const [planList,setPlanList] = useState([])

    // 支援プラン選択
    const [limitDiv,setLimitDiv] = useState("")
    const [selectionPlans,setSelectionPlans] = useState([])
    const columns = [
        { field: 'name', headerName: 'プラン名', width: 130, sortable: false, disableColumnMenu: true },
        { field: 'amount', headerName: '月額', width: 130, sortable: false, disableColumnMenu: true },
        {
          field: 'count',
          headerName: '支援者数',
          type: 'number',
          width: 90,
          sortable: false,
          disableColumnMenu: true
        },
        { field: 'age_limit', headerName: '年齢制限', width: 130, sortable: false, disableColumnMenu: true },
    ]  
    const [rows,setRows] = useState([])
    const [unitSell,setUnitSell] = useState("2")
    const [unitAmount,setUnitAmount] = useState(500)

    useEffect(() => {
        if(unitSell === "1" && unitAmount === -1){
            setUnitAmount(500)
        } else if(unitSell === "2") {
            setUnitAmount(-1)
        }
    },[unitSell])

    // キャラクター
    const [characterList,setCharacterList] = useState([])
    const [selectedCharacterList,setSelectedCharacterList] = useState([])

    const [fanart,setFanart] = useState("2")
    useEffect(() => {
        if(fanart === "2"){
            setSelectedCharacterList([])
        }
    },[fanart])

    // パラメータ
    const param = useParams()
    let groupId = props.groupId

    // 画像遅延ロード
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
    }

    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
              }
        })
    }, options);

    function edit(groupId,title,description,original,limitedPublication,displayNewList,displayRanking,prompt,negativePrompt,selectedCharacterList){
        setSaving(true)
        new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/upload/image",
            {groupId:groupId,title:title,description:description,original:original,
                limitedPublication:limitedPublication,limitDiv:limitDiv,selectionPlans:selectionPlans,unitAmount:unitAmount,
                displayNewList:displayNewList,displayRanking:displayRanking,ageLimit:ageLimit,sexualExpression:sexualExpression,styleOfPainting:styleOfPainting,prompt:prompt,negativePrompt:negativePrompt,
                selectedCharacterList:selectedCharacterList}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    dialog(t("common.confirm"),"更新が完了しました。")
                } else {
                    dialog(t("common.error"),json.errors.join("\r\n"))
                }
                setSaving(false)
                return json.result
            })
        })
    }
    const [limitedDataList,setLimitedDataList] = useState([])
    const [oldGroupId,setOldGroupId] = useState("")
    useEffect(() => {
        // タイトル設定
        //document.querySelector("title").textContent = t("common.edit") + " - " + t("common.siteName")
        getImageInfo(groupId).then(r => {
            if(r.result){
                setImageInfo(r)
                setImageInfoStatus(true)
                setAgeLimit(String(r.info.age_limit))
                setAgeLimitLock(String(r.info.age_limit_lock))
                if(String(r.info.age_limit) === "1"){
                    setSexualExpression("2")
                } else {
                    setSexualExpression(String(r.info.sexual_expression))
                }
                setStyleOfPainting(String(r.info.style_of_painting))
                let planList = r.info.plan_list || []
                setPlanList(planList)
                setSelectionPlans(planList.map(d => d.plan_id))
                setLimitDiv(r.info.limit_div)
                // 支援者限定コンテンツを取得
                let limitedList = []
                r.detail.map((d,i) => {
                    console.log("a",d.sort_order)
                    return getLimitedDataList(groupId,i).then(r => {
                        if(r.result){
                            d.base64 = r.list
                        } else {
                            d.base64 = []
                        }
                        limitedList[d.sort_order] = r.list
                        setLimitedDataList(limitedList)
                        console.log("b",d.sort_order)
                    })
                })
                setUnitSell(r.info.unit_amount > -1 ? "1" : "2")
                setUnitAmount(r.info.unit_amount)
                let list = []
                for(let i = 0;i < r.info.character_list.length;i++){
                    list.push({"label":r.info.character_list[i].character_name,"id":r.info.character_list[i].character_id})
                }
                if(list.length > 0) setFanart("1")
                setSelectedCharacterList(list.concat([]))
                console.log(list)
            }
        })
        getPlanList().then(r => {
            if(r.result){
                setRows(r.data.map(d => {
                    d.id = d.plan_id
                    d.amount = "￥"+d.amount.toLocaleString()
                    return d
                }))
            } else {
                setRows([].concat())
            }
        })
        if(oldGroupId !== "" && oldGroupId !== groupId){
            props.switch(false)
        }
        setOldGroupId(groupId)
    },[groupId])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageInfo,groupId])

    // エラーメッセージ
    const [message, setMessage] = useState('');
    const [messageShow, setMessageShow] = useState('none');

    const nenrei = [
        { name: t("upload.image.ageLimitG"), value: '1' },
        { name: t("upload.image.ageLimitPG12"), value: '2' },
        { name: t("upload.image.ageLimitR15"), value: '3' },
        { name: t("upload.image.ageLimitR18"), value: '4' },
        { name: t("upload.image.ageLimitR18G"), value: '5' },
    ];

    const yesOrNoRadio = [
        { name: t("common.yes"), value: "1" },
        { name: t("common.no"), value: "2" },
    ];

    const [showMosaicEditPopup,setShowMosaicEditPopup] = useState(false)
    const [saving,setSaving] = useState(false)
    document.onkeydown = (e) => {
        if(e.key === "Escape"){
            props.switch(false)
        }
    }

    const [styleOfPainting, setStyleOfPainting] = useState('')
    const styles = [
        { name: t("upload.image.illustration"), value: '1' },
        { name: t("upload.image.semirealism"), value: '3' },
        { name: t("upload.image.photorealistic"), value: '2' },
    ]
    const theme = useTheme();
    return (
    <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",backgroundColor:"#000000",zIndex:theme.zIndex.appBar + 2}}>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        {showMosaicEditPopup ? <MosaicEditPopup type="image" switch={setShowMosaicEditPopup} groupId={groupId} detailId={detailId} detailNo={detailNo} /> : ""}
        <div id="edit-popup" style={{position:"fixed",top:"1%",left:"1%",width:"98%",height:"98%",zIndex:5,overflow:"auto",backgroundColor:"#FFFFFF",borderRadius:"20px"}}>
        <Button variant='secondary' className='m-3' style={{position:"fixed",left:"14px",zIndex:1}} onClick={() => props.switch(false)}>{t("common.close")}</Button>
        <Container className='d-flex flex-row justify-content-center flex-wrap' style={{marginTop:"60px",marginBottom:"200px"}}>
            <Tabs defaultActiveKey="account" id="uncontrolled-tab-example" className="mt-3 mb-3 w-100">
                <Tab eventKey="account" title={t("upload.image.title")} style={{position:"relative",flex:"1"}}>
                    {imageInfoStatus && imageInfo.info.problem_status === 1 ? (
                    <Container style={{color:"red",fontWeight:"bold",fontSize:"24px",border:"3px solid red"}} className="mb-3">
                        {imageInfo.info.problem_reason === 1 ? <>隠蔽処理(モザイク等)の対応が必要です。<br /><Icon.Pencil />マークでモザイク編集することもできます。</> : <>児童ポルノまたは類似表現の修正が必要です。</>}
                    </Container>
                    ) : ""}
                    {imageInfoStatus && imageInfo.detail.length > 0 ? (
                    <Container className="d-flex justify-content-start align-items-center" style={{flexWrap:"wrap",width:"100%",padding:"5px",backgroundColor:"#FFFFFF",border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                        {imageInfo.detail.map((d,i) => {
                            return (
                                <div style={{position:"relative",flexShrink:0,width:"100px",height:"100px",overflow:"hidden"}} className="m-1" key={d.id}>
                                    <Icon.PencilFill style={{color:"#0000FF",fontSize:"24px",position:"absolute",right:"5px",top:"5px",borderRadius:"20px",backgroundColor:"#FFFFFF",cursor:"pointer"}}
                                        onClick={(e) => {
                                        setShowMosaicEditPopup(true)
                                        setDetailId(d.id)
                                        setDetailNo(d.sort_order)
                                    }} title={t("common.editMosaic")} />
                                    <Image src={limitDiv === "public" ? "http://"+ApiFetch.IMG_HOST+"/post/t/"+d.id+".jpg" : limitedDataList[i] !== undefined ? limitedDataList[i].t_m_webp : ""} style={{objectFit:"cover",width:"100%",height:"100%"}} className="lazy" />
                                </div>
                            )
                        })}
                    </Container>
                    ) : ""}
                    <pre style={{backgroundColor:"#555555",color:"#FFFFFF",padding:"10px",borderRadius:"5px",display:messageShow}}>{message}</pre>
                    <Form style={{margin:"0 auto",position:"relative",width:"100%",marginTop:"20px"}}>
                        <FloatingLabel controlId="title" label={t("upload.image.imageTitle")} className="mb-3 w-100">
                            <Form.Control type="text" placeholder="" required defaultValue={imageInfo.info.title} />
                        </FloatingLabel>                        
                        <FloatingLabel controlId="description" label={t("upload.image.imageDescription")} className='mb-3 w-100'>
                            <Form.Control
                                as="textarea"
                                style={{ height: '100px' }}
                                required
                                defaultValue={imageInfo.info.description}
                            />
                        </FloatingLabel>
                        <InputGroup className="mb-3">
                            <InputGroup.Checkbox style={{cursor:"pointer"}} id="original" defaultChecked={imageInfo.info.original} />
                            <Form.Control type="text" value={t("upload.image.original")} readOnly />
                        </InputGroup>
                        <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                            <InputGroup.Checkbox style={{cursor:"pointer"}} id="limited-publication" defaultChecked={imageInfo.info.limited_publication} />
                            <Form.Control type="text" value={t("upload.image.limitedPublication")} readOnly />
                        </InputGroup>
                        <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                            <InputGroup.Checkbox style={{cursor:"pointer"}} id="display-new-list" defaultChecked={imageInfo.info.display_new_list} />
                            <Form.Control type="text" value={t("upload.image.newPostHidden")} readOnly />
                        </InputGroup>
                        <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                            <InputGroup.Checkbox style={{cursor:"pointer"}} id="display-ranking" defaultChecked={imageInfo.info.display_ranking} />
                            <Form.Control type="text" value={t("upload.image.rankingHidden")} readOnly />
                        </InputGroup>
                        <Container className='mb-3'>
                            <p className='d-inline '>{t("upload.image.styleOfPainting")} </p>
                            <ButtonGroup>
                                {styles.map((radio, idx) => (
                                    <ToggleButton
                                        key={idx}
                                        id={`style-${idx}`}
                                        type="radio"
                                        variant={'outline-primary'}
                                        name="style-radio"
                                        value={radio.value}
                                        checked={styleOfPainting === radio.value}
                                        onChange={(e) => {
                                            setStyleOfPainting(e.currentTarget.value)
                                        }}
                                        >
                                        {radio.name}
                                    </ToggleButton>
                                ))}
                            </ButtonGroup>
                        </Container>
                        <Container className='d-flex flex-row justify-content-between mb-3'>
                            <p className='d-inline '>{t("upload.image.ageLimit")} </p>
                            <ButtonGroup>
                                {nenrei.map((radio, idx) => (
                                    <ToggleButton
                                        key={idx}
                                        id={`age-limit-${idx}`}
                                        type="radio"
                                        variant={'outline-primary'}
                                        name="radio"
                                        value={radio.value}
                                        checked={ageLimit === radio.value}
                                        onChange={(e) => {
                                            if(e.currentTarget.value === "3" || e.currentTarget.value === "4" || e.currentTarget.value === "5"){
                                                setSexualExpression("")
                                            }
                                            if(e.currentTarget.value === "1"){
                                                setSexualExpression("")
                                            }
                                            if(e.currentTarget.value === "2"){
                                                setSexualExpression("1")
                                            }
                                            setAgeLimit(e.currentTarget.value)
                                        }}
                                        disabled={!(loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator")) && ageLimitLock > radio.value}
                                        >
                                        {radio.name}
                                    </ToggleButton>
                                ))}
                            </ButtonGroup>
                        </Container>
                        <div className='mb-3' style={{display:ageLimit === "1" ? "flex" : "none"}}>
                            <p className='d-inline m-2'>{t("upload.image.whatIsSexual")} </p>
                            <ButtonGroup className='m-2'>
                                {yesOrNoRadio.map((radio, idx) => (
                                    <ToggleButton
                                        key={idx}
                                        id={`sexual-expression-${idx}`}
                                        type="radio"
                                        variant={'outline-primary'}
                                        name="sexual-radio"
                                        value={radio.value}
                                        checked={sexualExpression === radio.value}
                                        onChange={(e) => {
                                            if(e.currentTarget.value === "1"){
                                                setAgeLimit("2")
                                            }
                                            setSexualExpression(e.currentTarget.value)
                                        }}
                                        disabled={!(loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator")) && radio.value === "2" && ageLimitLock > 1}
                                        >
                                        {radio.name}
                                    </ToggleButton>
                                ))}
                            </ButtonGroup>
                            <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("PG12とは ",
                                <p>
                                    ■性的表現(軽微なものを含む) 
                                    性的なものを想起させる、接吻、抱擁・下着の露出など。
                                    性行為や類似する動作を連想させる表現や表情。
                                    胸や谷間、乳首、臀部、股間等の強調や際どい表現や構図。
                                    極端に面積の少ない衣類や水着を身に着けた人物の描画や、
                                    露出度の非常に高い人物の描写、透けた衣服を身に着けた人物の描写や全裸等。<br />
                                    ■その他刺激的な表現
                                    軽微な創傷や流血、薬物の登場、児童が真似をする可能性のあるもの
                                    流血表現または刺激的にはオプションのセンシティブフラグをつけてください。
                                </p>)} />
                        </div>
                        <div>
                            <div style={{border:"1px solid #BBBBBB",borderRadius:"5px"}} className='p-2 d-inline-block'>
                                <div>公開設定</div>
                                <MuiButton onClick={() => setLimitDiv("public")} className='m-1' variant={limitDiv === "public" ? 'contained' : "outlined"} disableElevation>全体公開</MuiButton>
                                <MuiButton onClick={() => setLimitDiv("plans")} className='m-1' variant={limitDiv === "plans" ? 'contained' : "outlined"} disableElevation disabled={loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0}>プランを選択</MuiButton>
                                <MuiButton onClick={() => setLimitDiv("any_plans")} className='m-1' variant={limitDiv === "any_plans" ? 'contained' : "outlined"} disableElevation disabled={loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0}>すべての有料プラン</MuiButton>
                                <div style={{ height: 400, width: '100%',display:limitDiv === "plans" ? "block" : "none" }} className='mt-3'>
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        checkboxSelection
                                        pageSizeOptions={[]}
                                        onRowSelectionModelChange={(selection) => {
                                            setSelectionPlans(selection)
                                        }}
                                        rowSelectionModel={selectionPlans}
                                        
                                    />
                                </div>
                            </div>
                            <br />
                            <div style={{border:"1px solid #BBBBBB",borderRadius:"5px"}} className='p-2 d-inline-block mt-1 mb-3'>
                                この投稿を販売&nbsp;
                                <ButtonGroup>
                                    {yesOrNoRadio.map((radio, idx) => (
                                        <ToggleButton
                                            className='p-1'
                                            key={idx}
                                            id={`unit-sell-${idx}`}
                                            type="radio"
                                            variant={'outline-primary'}
                                            name="unit-sell-radio"
                                            value={radio.value}
                                            checked={unitSell === radio.value}
                                            onChange={(e) => {
                                                setUnitSell(e.currentTarget.value)
                                            }}
                                            disabled={loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0}
                                            >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>&nbsp;
                                {unitSell === "1" ? (
                                <TextField
                                    type='number'
                                    value={unitAmount}
                                    onChange={(e) => setUnitAmount(e.currentTarget.value)}
                                    label="販売価格"
                                    id="unit-amount"
                                    sx={{ m: 1, width: '25ch' }}
                                    disabled={unitSell === "2" || loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0}
                                />
                                ) : ""}
                                <Tooltip title="投稿を単品で販売する場合の金額を設定します。プランに指定されていても購入していれば閲覧できます。" arrow>
                                    <Icon.InfoCircle  />
                                </Tooltip>
                            </div>
                        </div>
                        <div style={{margin:"0 auto 10px auto",display:loginInfo.result !== undefined && loginInfo.result ? "block" : "none"}}>
                            <div style={{border:"1px solid #BBBBBB",borderRadius:"5px"}} className='p-2 d-inline-block mt-1'>
                                ファンアートとして投稿する&nbsp;
                                <ButtonGroup>
                                    {yesOrNoRadio.map((radio, idx) => (
                                        <ToggleButton
                                            className='p-1'
                                            key={idx}
                                            id={`fanart-${idx}`}
                                            type="radio"
                                            variant={'outline-primary'}
                                            name="fanart-radio"
                                            value={radio.value}
                                            checked={fanart === radio.value}
                                            onChange={(e) => {
                                                setFanart(e.currentTarget.value)
                                            }}
                                            >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>&nbsp;
                                {fanart === "1" ? (
                                <Typeahead id="character-list" placeholder={"キャラクターを検索して追加"} clearButton={true}
                                    multiple
                                    onInputChange={(input) => {
                                        // キャラクター
                                        getCharacterList(input).then(r => {
                                            if(r.result){
                                                let list = []
                                                for(let i = 0;i < r.data.length;i++){
                                                    list.push({"label":r.data[i].character_name,"id":r.data[i].group_id})
                                                }
                                                setCharacterList(list.concat([]))
                                            }
                                        })
                                    }}
                                    selected={selectedCharacterList}
                                    onChange={(selected) => {
                                        //let value = selected.length === 0 ? "" : selected[0]
                                        setSelectedCharacterList(selected)
                                    }}
                                    options={characterList}
                                />
                                ) : ""}
                                {fanart === "1" ? "" : <Tooltip title="ファンアートを投稿する場合は、登場するキャラクターを検索して設定してください。" arrow>
                                    <Icon.InfoCircle  />
                                </Tooltip>}
                            </div>
                        </div>
                        <span style={{display:false === "1" ? "block" : "none"}}>使用モデル</span>
                        <Form.Select id="ai-model" className="mb-3" style={{display:false === "1" ? "block" : "none"}}>
                            <option value="no-select">更新なし</option>
                            <option value="NovelAI">NovelAI</option>
                            <option value="Holara">Holara</option>
                            <option value="AnythingV3">Anything V3</option>
                            <option value="AbyssOrangeMix">AbyssOrangeMix</option>
                            <option value="ACertainThing">ACertainThing</option>
                            <option value="ACertainModel">ACertainModel</option>
                            <option value="ACertainty">ACertainty</option>
                            <option value="Baka-DiffusionV1">Baka-DiffusionV1</option>
                            <option value="Elysium_V1">Elysium_V1</option>
                            <option value="Elysium_Anime_V1">Elysium_Anime_V1</option>
                            <option value="Elysium_Anime_V2">Elysium_Anime_V2</option>
                            <option value="Elysium_Anime_V3">Elysium_Anime_V3</option>
                            <option value="Elysium_Kuro_Anime_V1">Elysium_Kuro_Anime_V1</option>
                            <option value="Shirayuki_General_V1">Shirayuki_General_V1</option>
                            <option value="Shirayuki_Anime_V1">Shirayuki_Anime_V1</option>
                            <option value="WaifuDiffusion">Waifu Diffusion</option>
                            <option value="StableDiffusion">Stable Diffusion</option>
                            <option value="Midjouney">Midjouney</option>
                            <option value="Nijijourney">niji・journey</option>
                            <option value="TrinArt">TrinArt</option>
                            <option value="Dalle-2">Dalle-2</option>
                            <option value="Ernie-vilg">Ernie-vilg</option>
                            <option value="UnstableDiffusion">Unstable Diffusion</option>
                            <option value="HentaiDiffusion">HentaiDiffusion</option>
                            <option value="MeituAIPainting">Meitu AI Painting</option>
                            <option value="Rivera">Rivera</option>
                            <option value="original">オリジナルモデル</option>
                        </Form.Select>
                        <FloatingLabel controlId="prompt" label="生成テキスト、プロンプト(任意)" className='mb-3 w-100' style={{display:false === "1" ? "block" : "none"}}>
                            <Form.Control
                                as="textarea"
                                style={{ height: '100px' }}
                                required
                                defaultValue={imageInfo.info.prompt}
                            />
                        </FloatingLabel>
                        <FloatingLabel controlId="negative-prompt" label="ネガティブプロンプト(任意)" className='mb-3 w-100' style={{display:false === "1" ? "block" : "none"}}>
                            <Form.Control
                                as="textarea"
                                style={{ height: '100px' }}
                                required
                                defaultValue={imageInfo.info.negative_prompt}
                            />
                        </FloatingLabel>
                        {loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator") && imageInfo.info.user_id !== loginInfo.userId ? (
                        <Container style={{color:"red",fontWeight:"bold",fontSize:"24px",border:"3px solid red"}} className="mb-3">
                            管理者権限で編集中です。
                        </Container>
                        ) : ""}
                        <div className='mt-3'>
                            <Button onClick={(e) => {
                                let title = document.getElementById("title")
                                let description = document.getElementById("description")
                                if(title.value.trim().length === 0 ){
                                    dialog(t("common.error"),"タイトルを入力して下さい。")
                                    return false
                                }
                                /*if(description.value.trim().length === 0){
                                    dialog("エラー","概要を入力して下さい。")
                                    return false
                                }*/
                                if(ageLimit === ""){
                                    dialog(t("common.error"),"年齢制限を指定して下さい。")
                                    return false
                                }
                                // 全年齢の場合、性的表現について必須
                                if(ageLimit === "1" || ageLimit === "2"){
                                    if((sexualExpression === "" || sexualExpression === "0") && ageLimit === "1"){
                                        dialog(t("common.error"),"PG12の対象かを指定して下さい。")
                                        return false
                                    }
                                } else if(ageLimit === "3" || ageLimit === "4" || ageLimit === "5"){
                                    if((sexualExpression !== "" && sexualExpression !== "0")){
                                        dialog(t("common.error"),"年齢制限がR指定の場合、PG12の選択は不要です。")
                                        return false
                                    }
                                }
                                let promptStr = ""
                                let negativePromptStr = ""
                                let descriptionStr = description.value.trim()
                                let aiModel = document.getElementById("ai-model")
                                let prompt = document.getElementById("prompt")
                                let negativePrompt = document.getElementById("negative-prompt")
                                if(aiModel.value === ""){
                                    dialog(t("common.error"),"AIモデルを選択してください。")
                                    return false
                                }
                                if(prompt.value.trim().length > 10000){
                                    dialog(t("common.error"),"生成テキスト、プロンプトの上限は10,000文字です。")
                                    return false
                                }
                                if(negativePrompt.value.trim().length > 10000){
                                    dialog(t("common.error"),"ネガティブプロンプトの上限は10,000文字です。")
                                    return false
                                }
                                if(aiModel.value !== "no-select"){
                                    descriptionStr += "\n#" + aiModel.value
                                }
                                promptStr = prompt.value.trim()
                                negativePromptStr = negativePrompt.value.trim()

                                let original = document.getElementById("original").checked ? "1" : "0"
                                let limitedPublication = document.getElementById("limited-publication").checked ? "1" : "0"
                                let displayNewList = document.getElementById("display-new-list").checked ? "1" : "0"
                                let displayRanking = document.getElementById("display-ranking").checked ? "1" : "0"

                                edit(groupId,title.value.trim(),descriptionStr,original,limitedPublication,displayNewList,displayRanking,promptStr,negativePromptStr,selectedCharacterList.map(d => d.id))
                            }}>{saving ? (<Spinner animation="border" size="sm" />) : ""} {imageInfoStatus && imageInfo.info.problem_status === 1 ? "審査依頼" : t("common.update")}</Button>
                            <Button variant='danger' style={{marginLeft:"10px"}} onClick={()=>{
                                dialog(t("common.confirm"),
                                    <Container className='text-center' style={{margin:"0 auto"}}>
                                        <Container>{t("common.delete")}</Container>
                                        <Button
                                        onClick={() => {
                                            deleteImage(groupId).then(r=>{
                                                if(r.result){
                                                    dialog(t("common.confirm"),t("common.deleted"))
                                                } else {
                                                    dialog(t("common.error"),r.errors)
                                                }
                                            })
                                        }}
                                        >{t("common.deleteStr")}</Button>
                                    </Container>
                                    )
                            }}>{t("common.deleteStr")}</Button>
                        </div>
                    </Form>
                </Tab>
            </Tabs>
        </Container>
        </div>
    </div>
    )
}

export default EditPopup;
